import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Shield, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Shield className="h-8 w-8 text-accent" />
              <div>
                <h3 className="font-heading font-bold text-xl">CRITTER WHISPERER CHARLIE</h3>
                <p className="text-sm text-primary-foreground/70">Patrick Enterprises Canada</p>
              </div>
            </div>
            <p className="text-primary-foreground/80 mb-4 font-body">
              Professional wildlife control and animal removal services. Fully licensed and insured. 
              We use humane live trapping methods to protect both your property and local wildlife.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/patrickenterprises"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-foreground/70 hover:text-accent transition-colors"
                data-testid="facebook-link"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg uppercase mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-services-link">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-areas-link">
                  Service Areas
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-foreground/80 hover:text-accent transition-colors" data-testid="footer-contact-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-lg uppercase mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:343-263-2000"
                  className="flex items-center gap-2 text-primary-foreground/80 hover:text-accent transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone className="h-4 w-4" />
                  343-263-2000
                </a>
              </li>
              <li>
                <a
                  href="mailto:patrickenterprisescanada@gmail.com"
                  className="flex items-center gap-2 text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                  data-testid="footer-email-link"
                >
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  <span className="break-all">patrickenterprisescanada@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2 text-primary-foreground/80">
                  <MapPin className="h-4 w-4 flex-shrink-0 mt-1" />
                  <span>529 Thrasher Rd<br />Plainfield, ON K0K 2V0</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-foreground/60 text-sm">
            © {new Date().getFullYear()} Patrick Enterprises Canada. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-primary-foreground/60">
            <span className="flex items-center gap-1">
              <Shield className="h-4 w-4 text-accent" />
              Fully Licensed
            </span>
            <span>•</span>
            <span>Fully Insured</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
